import React, { useEffect } from 'react'
import Address from "../../../assets/images/address.png";
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const selectUser = createSelector(
  (state: any) => state.User,
  (user) => user?.user
);

const OnboardingAddress = () => {  
  
  const user = useSelector(selectUser);

  useEffect(() => {
  }, [user]);

  let isAddressAdded = user?.storeStatus?.isAddressAdded ?? false;

  return (
    <>
      <div className='d-grid gap-3 align-items-center justify-content-center flex-column'>
        <figure className=" m-0 p-0 d-flex align-items-center justify-content-center">
          <img
           className="w-25 h-25 m-0 p-0 object-contain"
            src={Address}
            alt="Email Communication"
          />
        </figure>
        <h1 className='text-center fs-3'>Add a shop/pick-up address</h1>
        {/* <h4 className='text-center text-gray-300 m-0 p-0 text-black-50'>no video</h4> */}
        {/* <Link to="/shop-address" className="text-muted text-center">
        <button type="button" data-testing-Id="addressAdd_onBoarding" className="btn btn-success w-50 me-auto ms-auto">Add</button>
        </Link>
        <div className='mx-auto p-1 rounded bg-success bg-opacity-25 cursor-pointer'>
          <p className='p-0 text-black-50 m-0 d-flex align-items-center '> <i className="bx bx-check-circle m-0 p-0 text-success fs-5 me-1"></i> Your business address has been uploaded successfully!</p>
        </div> */}
        {!isAddressAdded && (
        <Link to="/shop-address" className="text-muted text-center">
          <button
            type="button"
            data-testing-Id="addressAdd_onBoarding"
            className="btn btn-success w-50 me-auto ms-auto"
          >
            Add
          </button>
        </Link>
      )}
 {isAddressAdded && (
  <div className="d-flex flex-column align-items-center justify-content-center gap-3">
    <Link to="/shop-address">
      <button
        type="button"
        data-testing-Id="addressAdd_onBoarding"
        className="btn btn-success"
      >
        Update
      </button>
    </Link>
    <div className="p-1 rounded bg-success bg-opacity-25 cursor-pointer d-flex align-items-center">
      <i className="bx bx-check-circle text-success fs-5 me-1"></i>
      <p className="mb-0 text-black-50">Your business address has been uploaded successfully!</p>
    </div>
  </div>
)}
        {/* <h4 className='text-center text-gray-300 m-0 p-0 text-black-50'>Your business address has been uploaded successfully!</h4> */}
      </div>
    </>
  )
}

export default OnboardingAddress




